type DeliveryPointArchiveAction = 'archive' | 'restore';

type SegmentChangeAction = 'change' | 'detach';

type ConfirmDialogContent = {
  title: string;
  describe: (deliveryPointName: string) => string;
  confirmLabel: string;
};

type SegmentChangeDialogContent = {
  title: string;
  description: string;
  confirmLabel: string;
};

type DeliveryPointDetailsTab = { id: string; label: string; value: string; disabled?: boolean };

export const DELIVERY_POINT_DETAILS_CONFIRM_DIALOG_CONTENT: Record<DeliveryPointArchiveAction, ConfirmDialogContent> = {
  archive: {
    title: 'Archiver le point de livraison',
    describe: (deliveryPointName) =>
      `Le point « ${deliveryPointName} » sera retiré des listes et des formulaires de commande, et pourra être restauré.`,
    confirmLabel: 'Archiver',
  },
  restore: {
    title: 'Restaurer le point de livraison',
    describe: (deliveryPointName) => `Le point « ${deliveryPointName} » reviendra inactif.`,
    confirmLabel: 'Restaurer',
  },
};

export const DELIVERY_POINT_SEGMENT_CHANGE_DIALOG_CONTENT: Record<SegmentChangeAction, SegmentChangeDialogContent> = {
  change: {
    title: 'Changer le segment du point de livraison',
    description: 'Les factures de segment des commandes non encore facturées suivront le nouveau segment.',
    confirmLabel: 'Confirmer',
  },
  detach: {
    title: 'Détacher le point de livraison de son segment',
    description:
      "Sans segment, les commandes de ce point de livraison ne tomberont dans aucune facture de segment. Ce détachement s'appliquera dès l'enregistrement.",
    confirmLabel: 'Confirmer',
  },
};

export const DELIVERY_POINT_DETAILS_TABS: DeliveryPointDetailsTab[] = [
  { id: 'statistics', label: 'Statistiques', value: 'statistics', disabled: true },
  { id: 'informations', label: 'Informations', value: 'informations' },
  { id: 'orders', label: 'Commandes', value: 'orders' },
  { id: 'invoicing', label: 'Facturation', value: 'invoicing', disabled: true },
];

const DEFAULT_DELIVERY_POINT_DETAILS_TAB = 'informations';

export const resolveDeliveryPointDetailsTab = (requestedTab: string | null): string =>
  DELIVERY_POINT_DETAILS_TABS.find((tab) => tab.id === requestedTab && !tab.disabled)?.id ??
  DEFAULT_DELIVERY_POINT_DETAILS_TAB;
